import React, { useEffect, useMemo, useRef } from 'react';

import { gsap } from 'gsap';
import { useLocation } from 'react-router-dom';

import AlertImage from '@pkg/assets/images/alert.png';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { removeAlert } from '@app/store/slices';

import './ErrorPopup.scss';

export const YatErrorPopup = () => {
    const dispatch = useAppDispatch();
    const message = useAppSelector((rootState) => rootState.alert.message);
    const visible = useAppSelector((rootState) => rootState.alert.visible);
    const closeTimestamp = useAppSelector((rootState) => rootState.alert.closeTimestamp);

    const location = useLocation();
    const errorRef = useRef<HTMLDivElement>(null);

    const className = useMemo(() => {
        let result = '';
        if (location.pathname === '/checkout') {
            result += ' checkout';
        }
        return result;
    }, [location]);

    useEffect(() => {
        if (!errorRef.current) {
            return;
        }
        const init = { opacity: 0 };
        const full = { opacity: 1 };

        gsap.defaults({
            duration: 0.5,
        });

        if (visible) {
            gsap.fromTo('.yat-error', init, full);
        } else {
            gsap.fromTo('.yat-error', full, init);
        }
    }, [visible, errorRef]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (new Date().getTime() >= closeTimestamp) {
                dispatch(removeAlert());
            }
        }, 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, [closeTimestamp, dispatch]);

    if (!visible) {
        return null;
    }

    return (
        <div ref={errorRef} role="alert" className={`yat-error ${className}`}>
            <img src={AlertImage} alt="alert-icon" className="yat-error__icon" />
            <p className="yat-error__message v2-text-xs">{message}</p>
        </div>
    );
};
